import type from "./type";

export default type("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
});



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/xml.js
// module id = 868
// module chunks = 0